<div class="product large-page">
  <div *ngIf="editable === false" class="editable-overlay">
    <div class="container">
      <span class="message" style="text-align: left">
        <div style="color: black">Während Deiner Bewerbung kannst Du Deine Daten nicht ändern.</div>
      </span>
    </div>
  </div>
  <div class="container" [class.externalEdit]="externalEdit">
    <app-continuous-action #continuousProduct></app-continuous-action>
    <div *ngIf="product" class="row custom-row">
      <div class="col-md-8">
        <form [formGroup]="productForm">
          <div class="row">
            <div class="form-container col-md-6">
              <div class="produkt-headline headline-text">Produkt</div>

              <markant-input
                required
                class="markant-input basic-text"
                formControlName="name"
                label="Name"
                [maxlength]="nameMaxLength"
                helper-character-counter="true"
                matTooltip="Gib den offiziellen Produktnamen an."
                matTooltipPosition="right"
              ></markant-input>

              <markant-input
                required
                formControlName="claim"
                class="markant-input"
                label="Claim"
                maxlength="255"
                helper-character-counter="true"
                matTooltip="Formuliere einen / euren kurzen Nutzen- oder Markenclaim, der das Produkt prägnant beschreibt."
                matTooltipPosition="right"
              ></markant-input>

              <markant-textarea
                class="markant-textarea"
                label="Beschreibung"
                show-character-counter="true"
                autogrow="true"
                maxlength="2500"
                required
                formControlName="description"
                class="u-full-width basic-text textarea"
                placeholder=""
                id="productDescription"
                matTooltip="Beschreibe das Produkt verständlich: Was ist es, wofür wird es genutzt und was macht es besonders?"
                matTooltipPosition="right"
              >
              </markant-textarea>

              <markant-input
                required
                formControlName="price"
                label="Preis in Euro"
                placeholder="Unverbindliche Preisempfehlung"
                pattern="^[0-9]+((\.|,)[0-9]{1,2})?$"
                class="markant-input underTextarea"
                matTooltip="Trage den Verkaufspreis (UVP) in Euro pro Stück ein."
                matTooltipPosition="right"
              ></markant-input>

              <markant-input
                required
                formControlName="packingUnit"
                label="Verpackungseinheit"
                placeholder="z.B. &bdquo;10 Flaschen pro Karton&ldquo;"
                class="markant-input"
                matTooltip="Gebe an, in welcher Einheit das Produkt verkauft wird (Stückzahl pro Verkaufskarton / Tray)."
                matTooltipPosition="right"
              ></markant-input>

              <markant-select
                formControlName="productGroup"
                [required]="true"
                label="Warenbereich"
                class="markant-input"
                matTooltip="Wähle die passende Produktkategorie aus Handelssicht aus."
                matTooltipPosition="right"
              >
                <markant-select-option *ngIf="false"></markant-select-option>
                <markant-select-option-group class="optionGroup" *ngFor="let group of productCategories" [label]="group.name">
                  <markant-select-option *ngFor="let productGroup of group.productGroups" [value]="productGroup.value">
                    {{ productGroup.viewValue }}
                  </markant-select-option>
                </markant-select-option-group>
              </markant-select>

              <markant-textarea
                label="Wo ist Dein Produkt bereits gelistet?"
                maxlength="250"
                autosize="true"
                required
                formControlName="listed"
                class="markant-input"
                matTooltip="Nenne alle Verkaufsorte, bei denen das Produkt aktuell für Konsumenten erhältlich ist (z. B. eigener Shop, Amazon, Einzelhändler etc.)."
                matTooltipPosition="right"
              ></markant-textarea>

              <div class="subheadline-text">Pitch Deck*</div>
              <app-pitch-deck
                [productId]="product.id"
                [currentPitchDeck]="pitchDeck"
                (pitchDeckChanged)="pitchDeckChanged($event)"
                [disabled]="!editable"
              ></app-pitch-deck>

              <div class="subheadline-text">Dokumente</div>
              <app-upload-document
                [productId]="product.id"
                [documents]="product.documents"
                [disabled]="!editable"
                (documentListChanged)="updateDocs($event)"
              ></app-upload-document>
            </div>
            <div class="col-md-6 center-stuff basic-text midBox">
              <img
                *ngIf="startup && startup.logo; else nologo"
                width="300"
                height="300"
                autogrow="true"
                style="margin-bottom: 1em; border: 1px solid #bed7eb"
                src="{{ startup.logo?.uri }}"
                alt=""
              />
              <ng-template #nologo>
                <div style="width: 300px; height: 300px; margin: auto; margin-bottom: 1em; background-color: lightgray"></div>
              </ng-template>
              <div class="coverImage">
                <app-continuous-action #continuousCoverImage [sticky]="false"></app-continuous-action>
                <img *ngIf="coverImage" height="300" width="300" [src]="coverImage.uri" style="border: 1px solid #bed7eb" alt="" />
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="col-md-4 startupWrapper">
        <ng-container *ngIf="startup">
          <div class="startup-view">
            <div class="startup-headline headline-text">{{ startup.nickname }}</div>

            <mat-card-content>
              <p class="u-full-width basic-text startup-description" id="startupDescription">
                {{ startup.description }}
              </p>
            </mat-card-content>

            <a class="basic-text" [attr.href]="Startup.extractLink(LinkType.WEBSITE, startup.links) | linkHttp">{{
              Startup.extractLink(LinkType.WEBSITE, startup.links)
            }}</a>

            <address class="basic-text" style="padding: 20px">
              {{ startup.name }}<br />
              {{ startup.street }}<br />
              {{ startup.zip }} {{ startup.city }}<br />
              +{{ startup.countryPhoneCode }} {{ startup.phone }}<br />
            </address>

            <p>
              <ng-container *ngIf="Startup.extractLink(LinkType.FACEBOOK, startup.links) as link">
                <a [attr.href]="link | linkHttp"><img class="social-media-icon" src="./assets/img/icon/facebook.svg" alt="" /></a>
              </ng-container>
              <ng-container *ngIf="Startup.extractLink(LinkType.TWITTER, startup.links) as link">
                <a [attr.href]="link | linkHttp"><img class="social-media-icon" src="./assets/img/icon/twitter.svg" alt="" /></a>
              </ng-container>
              <ng-container *ngIf="Startup.extractLink(LinkType.INSTAGRAM, startup.links) as link">
                <a [attr.href]="link | linkHttp"><img class="social-media-icon" src="./assets/img/icon/instagram.svg" alt="" /></a>
              </ng-container>
            </p>
          </div>
        </ng-container>
      </div>

      <div class="container" style="margin-bottom: 15px">
        <app-media-list
          style="margin-top: 15px"
          [productId]="product.id"
          [mediaList]="images"
          (mediaListChanged)="updateMedia($event)"
          (updatedCoverImage)="showEditCoverPopup($event)"
          [originId]="this.coverImage != undefined ? this.coverImage.originId : undefined"
          [disabled]="!editable"
          [startupName]="startup.name ? startup.name : ''"
          [productName]="product.name ? product.name : ''"
          [productCategory]="product.productGroup ? product.productGroup : ''"
        >
        </app-media-list>
      </div>
    </div>
  </div>
</div>
